__turbopack_context__.v({
  "text": "screen-reader-only-module-scss-module__Nr6Q3G__text",
});
